import {CalendarUtils} from "@/calendar-utils";
import {UserInfoModel} from "@/model/user-info/user-info.model";
import {UserInfoErrorMessageModel} from "@/model/user-info/user-info-error-message.model";

export class UserInfoInputModel extends UserInfoModel {

    /** エラーメッセージ */
    errorMessages: UserInfoErrorMessageModel = new UserInfoErrorMessageModel();

    // 生年月日（年）
    birthdayYear: string = "";

    // 生年月日（月）
    birthdayMonth: string = "";

    // 生年月日（日）
    birthdayDay: string = "";

    // 店舗コード
    storeCode: string = null;
    
    /** 名前初期状態フラグ（一度も入力されていない場合 true） */
    initName: boolean = true;
    
    /** 名前かな初期状態フラグ（一度も入力されていない場合 true） */
    initKana: boolean = true;
    
    /** 性別初期状態フラグ（一度も入力されていない場合 true） */
    initGender: boolean = true;
    
    /** 生年月日初期状態フラグ（一度も入力されていない場合 true） */
    initBirthday: boolean = true;
    
    /** 都道府県初期状態フラグ（一度も入力されていない場合 true） */
    initPrefecture: boolean = true;

    public copy(obj: UserInfoInputModel) {
        // 親のコピーを実行
        super.copy(obj);

        if (obj) {
            this.birthdayYear = obj.birthdayYear;
            this.birthdayMonth = obj.birthdayMonth;
            this.birthdayDay = obj.birthdayDay;
            this.storeCode = obj.storeCode;
            if(!this.birthdayYear && !this.birthdayMonth && !this.birthdayDay) {
                let date = CalendarUtils.decomposeDate(this.birthday);
                this.birthdayYear = date.year;
                this.birthdayMonth = date.month;
                this.birthdayDay = date.day;
            }
        }
    }
    
    /** 初期状態を設定します */
    public initialize() {
        this.initName = !this.name;
        this.initKana = !this.kana;
        this.initGender = !this.gender;
        this.initBirthday = !this.birthday;
        this.initPrefecture = !this.prefecture;
    }
    
    /** 初期状態を解除します */
    public deinitialize() {
        this.initName = false;
        this.initKana = false;
        this.initGender = false;
        this.initBirthday = false;
        this.initPrefecture = false;
    }

    /** 生年月日を返却 */
    public getBirthday(): string {
        return CalendarUtils.formatToJpn(this.birthdayYear, this.birthdayMonth, this.birthdayDay);
    }

    /** 生年月日を返却 */
    public getBirthdayHyphenFormat(): string {
        return CalendarUtils.formatToHyphen(this.birthdayYear, this.birthdayMonth, this.birthdayDay);
    }

}